export default __webpack_public_path__ + "static/media/skills-light.1e9a2136.svg";